import store from "@/store";

export const getIsChatDeleted = (chatId: string): boolean => {
  const isDeleted = store.getters.GET_CHAT_IS_DELETED(chatId);
  return isDeleted;
};
